import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { useEntity } from '../../hooks/useEntity';
import { MenuCard } from './MenuStyle';

interface EntityChangeEvent extends Event {
  detail: {
    element: {
      type: string;
      id: number;
    };
  };
}

export function Menu() {
  const menuElRef = useRef<(HTMLElement & { links?: unknown; internalLinking?: boolean }) | null>(null);

  const { entityId } = useEntity();
  const { authenticated, user } = useAuthContext();
  const navigate = useNavigate();
  const [remoteId, setRemoteId] = useState<number | null>(entityId ?? null);
  const location = useLocation();

  // (useEffect pour le changement d'URL)
  useEffect(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    if (parts.length >= 1) {
      const newId = parseInt(parts[0], 10);
      if (!isNaN(newId)) {
        setRemoteId(newId);
      }
    }
  }, [location]);

  const onEntityChange = useCallback(
    (evt: Event) => {
      const selectedEntityDetail = (evt as EntityChangeEvent).detail;
      if (!selectedEntityDetail || !selectedEntityDetail.element) {
        console.warn('Événement entity-change reçu sans "detail"');
        return;
      }
      const selectedEntity = selectedEntityDetail.element;
      setRemoteId(selectedEntity.id);
      user?.assignCurrentGroup(selectedEntity.id);

      const pathParts = location.pathname.split('/').filter(Boolean);
      let targetPage = 'liste';
      if (pathParts.length >= 2) {
        const currentPage = pathParts[1];
        if (currentPage === 'liste' || currentPage === 'echeances') {
          targetPage = currentPage;
        }
      }
      const newPath = `/${selectedEntity.id}/${targetPage}`;
      navigate(newPath);
    },
    [navigate, location, user]
  );

  const menuRefCallback = useCallback(
    (node: HTMLElement & { links?: unknown; internalLinking?: boolean }) => {
      if (menuElRef.current) {
        menuElRef.current.removeEventListener('entity-change', onEntityChange as EventListener);
      }
      menuElRef.current = node;
      if (node) {
        node.internalLinking = false;
        node.addEventListener('entity-change', onEntityChange as EventListener);
      }
    },
    [onEntityChange]
  );

  return (
    <MenuCard>
      {authenticated && user && (
        <preventionbtp-menu
          ref={menuRefCallback}
          userPermissionLevel={'Company'}
          remoteId={remoteId}
          entityType={'Company'}
          userAccessToken={user?.accessToken ?? null}
        ></preventionbtp-menu>
      )}
    </MenuCard>
  );
}
